import React, { PureComponent } from 'react';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import { SEARCHBOX_THEMES } from './SearchBox.constants';
import { messages } from './SearchBox.messages';
import { LocationFieldContainer } from './LocationFieldContainer';
import { KeywordFieldContainer } from './KeywordFieldContainer';
import css from './SearchBox.scss';

export class SearchBox extends PureComponent {
  renderSearchPanelCollapsed() {
    const {
      isMapView,
      keywordText,
      locationText,
      onClickCollapsedSearchBar,
      onToggleMapView,
      selectedVertical,
      shouldShowViewToggler,
    } = this.props;

    const text = keywordText || (selectedVertical && <LocalizableMessage message={messages[selectedVertical]} />) || '';

    return (
      <div className={css.searchbox__collapsed}>
        <div className={css.searchbox__collapsed__fieldInfo} onClick={onClickCollapsedSearchBar}>
          <Isvg src={DESIGN_SYSTEM_ICONS.lookingGlass} />
          <b>{text}</b>
          <span className="color-text-light">
            <LocalizableMessage message={locationText} />
          </span>
        </div>
        {shouldShowViewToggler && (
          <div className={css.searchbox__collapsed__viewToggler} onClick={onToggleMapView}>
            <span className={css.searchbox__collapsed__viewToggler__label}>
              <LocalizableMessage message={isMapView ? messages.listViewTogglerLabel : messages.mapViewTogglerLabel} />
            </span>
          </div>
        )}
      </div>
    );
  }

  renderSearchPanelExpanded() {
    const {
      isKeywordOpen,
      isKeywordOpenOnMobile,
      isLocationOpen,
      isLocationOpenOnMobile,
      isPanelOpen,
      isPanelOpenOnMobile,
      onPanelClose,
    } = this.props;

    return (
      <div
        className={cx(css.searchbox__controls, {
          [css['searchbox__controls--open']]: isPanelOpen,
        })}>
        {isPanelOpenOnMobile && (
          <div className={css.searchbox__controls__close} onClick={onPanelClose}>
            <Isvg src={DESIGN_SYSTEM_ICONS.arrowLeft} />
          </div>
        )}

        <div className={css.searchbox__controls__fields}>
          <KeywordFieldContainer isOpen={isKeywordOpen} isOpenPanelOnMobile={isKeywordOpenOnMobile} />

          <LocationFieldContainer isOpen={isLocationOpen} isOpenPanelOnMobile={isLocationOpenOnMobile} />
        </div>
      </div>
    );
  }

  render() {
    const { isHidden, isPanelOpenOnMobile, isSearchPanelCollapsed, theme } = this.props;

    return (
      <div
        className={cx(css.searchbox, {
          [css['searchbox--panel-open']]: isPanelOpenOnMobile,
          [css[`searchbox--theme-${theme}`]]: Object.values(SEARCHBOX_THEMES).includes(theme),
          hidden: isHidden,
        })}>
        {isSearchPanelCollapsed ? this.renderSearchPanelCollapsed() : this.renderSearchPanelExpanded()}
      </div>
    );
  }
}

SearchBox.propTypes = {
  isHidden: PropTypes.bool,
  isKeywordOpen: PropTypes.bool,
  isKeywordOpenOnMobile: PropTypes.bool,
  isLocationOpen: PropTypes.bool,
  isLocationOpenOnMobile: PropTypes.bool,
  isMapView: PropTypes.bool,
  isPanelOpen: PropTypes.bool,
  isPanelOpenOnMobile: PropTypes.bool,
  isSearchPanelCollapsed: PropTypes.bool,
  keywordText: PropTypes.string.isRequired,
  locationText: LocalizableMessageShape.isRequired,
  onClickCollapsedSearchBar: PropTypes.func.isRequired,
  onPanelClose: PropTypes.func.isRequired,
  onToggleMapView: PropTypes.func.isRequired,
  selectedVertical: PropTypes.string,
  shouldShowViewToggler: PropTypes.bool,
  theme: PropTypes.string,
};
